/*
  Icon Walls — Interaktive Effekte (cursor-reaktiver Glanz + dezenter 3D-Tilt).
  Vanilla, keine Abhängigkeiten. Aktiv nur bei feinem Pointer + erlaubter Motion.
  Setzt CSS-Custom-Props (--iw-px/--iw-py für den Glanz, --iw-rx/--iw-ry für den Tilt);
  das Rendering übernimmt iw-interactive.css.
*/
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fine.matches || reduce.matches) return;

  // Flächen, die den Glanz bekommen …
  var GLOW =
    '.iw-card, .iw-series__card, .iw-mega__tile, .iw-pill--primary, .iw-pill--ghost, .iw-pill--glass, .iw-glass, [data-iw-fx]';
  // … und die zusätzlich kippen (begrenzte Objekte, keine großen Panels).
  var TILT = '.iw-card, .iw-series__card, .iw-mega__tile, [data-iw-tilt]';

  function tag() {
    var nodes = document.querySelectorAll(GLOW);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.iwFx) continue;
      el.dataset.iwFx = '1';
      el.classList.add('iw-fx');
      if (el.matches(TILT)) el.classList.add('iw-fx--tilt');
    }
  }
  tag();

  // Neue Inhalte (Load-More, Filter, Cart-Drawer) nachträglich taggen — rAF-gebündelt.
  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      tag();
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });

  var active = null;
  var frame = 0;
  var lx = 0;
  var ly = 0;

  function clear(el) {
    if (!el) return;
    el.classList.remove('iw-fx--on');
    el.style.removeProperty('--iw-rx');
    el.style.removeProperty('--iw-ry');
  }

  function paint() {
    frame = 0;
    if (!active) return;
    var r = active.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = (lx - r.left) / r.width;
    var py = (ly - r.top) / r.height;
    px = px < 0 ? 0 : px > 1 ? 1 : px;
    py = py < 0 ? 0 : py > 1 ? 1 : py;
    active.style.setProperty('--iw-px', (px * 100).toFixed(1) + '%');
    active.style.setProperty('--iw-py', (py * 100).toFixed(1) + '%');
    if (active.classList.contains('iw-fx--tilt')) {
      // max ~3° Neigung, entgegengesetzt zur Cursor-Auslenkung
      active.style.setProperty('--iw-rx', ((0.5 - py) * 6).toFixed(2) + 'deg');
      active.style.setProperty('--iw-ry', ((px - 0.5) * 6).toFixed(2) + 'deg');
    }
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest('.iw-fx') : null;
      if (el !== active) {
        clear(active);
        active = el;
        if (el) el.classList.add('iw-fx--on');
      }
      if (!active) return;
      lx = e.clientX;
      ly = e.clientY;
      if (!frame) frame = requestAnimationFrame(paint);
    },
    { passive: true }
  );

  window.addEventListener('blur', function () {
    clear(active);
    active = null;
  });
  document.addEventListener(
    'pointercancel',
    function () {
      clear(active);
      active = null;
    },
    { passive: true }
  );
})();

/*
  Mobil: Produktkarten-Peek. Das zweite Bild (Room-Mockup) blendet erst ein,
  wenn eine Karte 3 s lang im Blickfeld bleibt — Tippen wechselt das Bild NICHT
  (der Hover-Swap ist per Media Query auf Maus-Geräte beschränkt, s. icon-walls.css).
  Verlässt die Karte den Blick, kehrt Bild 1 zurück; der 3-s-Zähler startet neu.
*/
(function () {
  var touch = window.matchMedia('(hover: none), (pointer: coarse), (max-width: 989px)');
  if (!touch.matches || !('IntersectionObserver' in window)) return;

  var DELAY = 3000;
  var timers = new WeakMap();

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        var t = timers.get(card);
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          if (t) return; // Zähler läuft schon bzw. Peek ist aktiv
          timers.set(
            card,
            setTimeout(function () {
              var img2 = card.querySelector('.iw-pcard__img--2');
              // Kein Peek, wenn das Mockup ausgeblendet ist (z. B. aktiver Material-Filter)
              if (img2 && img2.style.display !== 'none') card.classList.add('iw-peek');
            }, DELAY)
          );
        } else {
          if (t) {
            clearTimeout(t);
            timers.delete(card);
          }
          card.classList.remove('iw-peek');
        }
      });
    },
    { threshold: [0, 0.6] }
  );

  function tag(ctx) {
    var cards = (ctx || document).querySelectorAll('.iw-pcard');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.iwPeek) continue;
      cards[i].dataset.iwPeek = '1';
      io.observe(cards[i]);
    }
  }

  function boot() {
    tag();
    // Nachgeladene Karten (Infinite Scroll, Filter, Drawer) automatisch erfassen
    new MutationObserver(function () { tag(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
